import Input from '@/common/components/Input';
import { useTranslationContext } from '@/common/hooks/useTranslationContext';
import React from 'react';
import { mapInputsToAddressHU } from './mapInputsToAddressHU';

const InputsHU = ({ addressFormInputs, handleChangeInputValue }) => {
	const { translation } = useTranslationContext();

	return (
		<>
			<Input
				margin='6px'
				name={translation.postalCode}
				width={120}
				inputWidth={260}
				value={addressFormInputs.postalCode}
				requiredSign
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('postalCode', e)}
			/>
			<Input
				margin='6px'
				name={translation.city}
				width={120}
				inputWidth={260}
				value={addressFormInputs.city}
				requiredSign
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('city', e)}
			/>
			<Input
				margin='6px'
				name={translation.street}
				width={120}
				inputWidth={260}
				value={addressFormInputs.street}
				placeholder=''
				requiredSign
				controlled={true}
				onChange={(e) => handleChangeInputValue('street', e)}
			/>
			<Input
				margin='6px'
				name={translation.houseNumber}
				width={120}
				inputWidth={260}
				value={addressFormInputs.houseNumber}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('houseNumber', e)}
			/>
			<Input
				margin='6px'
				name={translation.building}
				width={120}
				inputWidth={260}
				value={addressFormInputs.building}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('building', e)}
			/>
			<Input
				margin='6px'
				name={translation.floor}
				width={120}
				inputWidth={260}
				value={addressFormInputs.floor}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('floor', e)}
				requiredSign={false}
			/>
			<Input
				margin='6px'
				name={translation.apartment}
				width={120}
				inputWidth={260}
				value={addressFormInputs.apartment}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('apartment', e)}
			/>
			<Input
				margin='6px'
				name={translation.additionalAddressLine2}
				width={120}
				inputWidth={260}
				value={addressFormInputs.addressLine2}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('addressLine2', e)}
			/>
			<Input
				margin='6px'
				name={translation.phone_number_for_courier}
				width={120}
				inputWidth={260}
				value={addressFormInputs.phoneForCourier}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('phoneForCourier', e)}
			/>
			<Input
				margin='6px'
				name={translation.courierInfo}
				width={120}
				inputWidth={260}
				value={addressFormInputs.additionalInfo}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('additionalInfo', e)}
			/>
			<div
				style={{
					marginTop: '18px',
				}}
			>
				<span
					style={{
						fontWeight: 'bold',
						marginRight: '12px',
					}}
				>
					{translation.address}:
				</span>
				<span>{mapInputsToAddressHU(addressFormInputs)}</span>
			</div>
		</>
	);
};

export default InputsHU;
